import SortableTable, {
  SortSettings,
} from "../../../../component/sortable-table/SortableTable";

interface TabContentProps {
  loadingData: boolean;
  headerJobsLine: string[];
  filteredJobsContent: (string | number)[][];
  sortSettings?: SortSettings;
  searchParam: string;
  headerIssueLine: string[];
  filteredIssuesContent: (string | number)[][];
  isTippingUser: boolean;

  changeSortAction: (col: number) => void;
  changeSearchParam: (search: string) => void;

  width: number;
  darkMode: boolean;
}

const TabContent = (props: TabContentProps) => {
  const contentArray = [];
  contentArray.push(
    <div className="table-content">
      {!props.loadingData ? (
        <SortableTable
          id="job-list"
          width={props.width}
          header={props.headerJobsLine}
          data={props.filteredJobsContent}
          standaloneTable
          hasDownloadLinks
          isTippingUser={props.isTippingUser}
          currentSort={props.sortSettings}
          onSortChanged={props.changeSortAction}
          currentFilterKey={props.searchParam}
          onFilterChanged={props.changeSearchParam}
          rowsPerPage={25}
          darkMode={props.darkMode}
          sourceDownload="purgo"
        />
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
  contentArray.push(
    <div className="table-content">
      {!props.loadingData ? (
        <SortableTable
          id="job-list"
          width={props.width}
          header={props.headerIssueLine}
          data={props.filteredIssuesContent}
          standaloneTable
          isTippingUser={props.isTippingUser}
          currentSort={props.sortSettings}
          onSortChanged={props.changeSortAction}
          currentFilterKey={props.searchParam}
          onFilterChanged={props.changeSearchParam}
          rowsPerPage={25}
          darkMode={props.darkMode}
          sourceDownload="purgo"
        />
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
  return contentArray;
};

export default TabContent;
